import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { API_URL } from '../utils/Functions';

export const primaryLinks = [
  { label: 'GST', href: '/#gst' },
  { label: 'Trademark', href: '/#trademark', dropdown: true },
  { label: 'Company Registration', href: '/#company-registration', dropdown: true },
  { label: 'ISO', href: '/#iso' },
  { label: 'FSSAI', href: '/#fssai' },
  { label: 'IEC', href: '/#iec' },
];

export const secondaryLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Services', href: '/#services' },
  { label: 'Blog', href: '/blogs' },
  { label: 'Careers', href: '/#careers' },
  { label: 'Contact', href: '/contact' },
];

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dynamicPages, setDynamicPages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace('#', '');
      const elem = document.getElementById(targetId);
      if (elem) {
        setTimeout(() => {
          elem.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${API_URL}/api/public/menus`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setDynamicPages(data.data || []);
        }
      })
      .catch(err => console.error('Failed to load menus', err))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

        .oli-navbar {
          font-family: 'Inter', sans-serif;
          background: #061830;
          border-bottom: 1px solid #1a2a40;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        }


        .oli-brand {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
          flex-shrink: 0;
          margin-right: 28px;
        }

        .oli-brand-logo {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: #fff;
          border: 2px solid #e0d060;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 900;
          font-size: 13px;
          color: #d32f2f;
          letter-spacing: -0.5px;
          line-height: 1;
          text-align: center;
          padding: 3px;
        }

        .oli-brand-text .brand-main {
          font-size: 14px;
          font-weight: 700;
          color: #ffffff;
          line-height: 1.2;
        }
        .oli-brand-text .brand-main span { color: #CFA047; }
        .oli-brand-text .brand-sub {
          font-size: 9px;
          color: #888;
          font-weight: 400;
          letter-spacing: 0.03em;
          white-space: nowrap;
        }

        /* Links area */
        .oli-links-wrapper {
          flex: 1;
          position: static;
          height: 60px;
          display: flex;
          align-items: center;
        }

        .oli-links-track {
          display: flex;
          align-items: center;
          gap: 2px;
          white-space: nowrap;
        }

        .oli-nav-link {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 6px 10px;
          font-size: 12.5px;
          font-weight: 500;
          color: #ffffff;
          text-decoration: none;
          border-radius: 6px;
          transition: background 0.15s ease, color 0.15s ease;
          white-space: nowrap;
        }
        .oli-nav-link:hover {
          background: rgba(255,255,255,0.1);
          color: #CFA047;
        }
        .oli-nav-link .caret {
          font-size: 9px;
          color: #aaa;
          margin-left: 1px;
        }

        .oli-nav-item {
          position: static;
          display: inline-flex;
        }

        .oli-mega-menu {
          position: absolute;
          top: calc(100% + 15px);
          left: 50%;
          transform: translateX(-50%) translateY(10px);
          /* width and grid-template-columns set via inline style dynamically */
          background: #ffffff;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          opacity: 0;
          visibility: hidden;
          transition: all 0.25s ease;
          border: 1px solid rgba(6,24,48,0.1);
          z-index: 1050;
          display: grid;
          gap: 15px;
        }

        .oli-nav-item:hover .oli-mega-menu {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }

        .oli-mega-col-title {
          display: block;
          color: #061830;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 10px;
          padding-bottom: 6px;
          border-bottom: 1px solid rgba(6,24,48,0.2);
          text-decoration: none;
        }

        .oli-mega-col-title:hover {
          color: #CFA047;
        }

        .oli-mega-item {
          display: block;
          color: #061830;
          text-decoration: none;
          font-size: 13px;
          font-weight: 500;
          padding: 5px 0;
          transition: color 0.2s, padding-left 0.2s;
        }

        .oli-mega-item:hover {
          color: #CFA047;
          padding-left: 3px;
        }

        /* Separator */
        .oli-sep {
          color: #ccc;
          font-size: 14px;
          user-select: none;
          flex-shrink: 0;
        }

        /* Three-dot button — premium */
        .oli-kebab-btn {
          flex-shrink: 0;
          margin-left: 10px;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          border: none;
          background: linear-gradient(135deg, #CFA047 0%, #a67f35 100%);
          box-shadow: 0 2px 8px rgba(207,160,71,0.35), 0 0 0 0px rgba(207,160,71,0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #fff;
          font-size: 13px;
          transition: box-shadow 0.25s ease, transform 0.35s cubic-bezier(0.34,1.56,0.64,1);
          position: relative;
          outline: none;
        }
        .oli-kebab-btn::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0) 60%);
          pointer-events: none;
        }
        .oli-kebab-btn:hover {
          box-shadow: 0 4px 18px rgba(207,160,71,0.55), 0 0 0 4px rgba(207,160,71,0.12);
          transform: scale(1.08);
        }
        .oli-kebab-btn.active {
          background: linear-gradient(135deg, #a67f35 0%, #CFA047 100%);
          box-shadow: 0 4px 20px rgba(207,160,71,0.6), 0 0 0 5px rgba(207,160,71,0.15);
          transform: rotate(90deg) scale(1.08);
        }
        .oli-kebab-btn i {
          position: relative;
          z-index: 1;
          text-shadow: 0 1px 2px rgba(0,0,0,0.2);
        }

        /* Per-link staggered slide-up + fade animation */
        .oli-nav-link {
          opacity: 0;
          transform: translateY(8px);
          animation: linkRise 0.35s cubic-bezier(0.34,1.56,0.64,1) forwards;
        }
        @keyframes linkRise {
          to { opacity: 1; transform: translateY(0); }
        }
        .oli-mobile-toggle {
          display: none;
        }
        /* Responsive adjustments */
        @media (max-width: 991px) {
          .oli-kebab-btn {
            display: none !important;
          }
          .oli-links-wrapper {
            display: none !important;
          }
          .oli-mobile-toggle {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            background: none;
            border: 1px solid #ccc;
            border-radius: 6px;
            font-size: 18px;
            color: #ffffff;
            margin-left: auto;
            cursor: pointer;
            transition: all 0.2s;
          }
          .oli-mobile-toggle:active {
            background: rgba(255,255,255,0.1);
          }
          .oli-mobile-menu {
            position: absolute;
            top: 60px;
            left: 0;
            width: 100%;
            background: #061830;
            border-bottom: 1px solid #1a2a40;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            z-index: 999;
            display: block;
            animation: slideDown 0.3s ease forwards;
            transform-origin: top;
            max-height: calc(100vh - 60px);
            overflow-y: auto;
          }
          @keyframes slideDown {
            from { opacity: 0; transform: scaleY(0.95); }
            to { opacity: 1; transform: scaleY(1); }
          }
          .oli-mobile-menu .oli-nav-link {
            padding: 14px 24px;
            font-size: 15px;
            color: #ffffff;
            text-decoration: none;
            border-bottom: 1px solid #1a2a40;
            opacity: 1;
            animation: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          }
          .oli-mobile-menu .oli-nav-link:last-child {
            border-bottom: none;
          }
          .oli-mobile-sublink {
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-decoration: none;
            transition: color 0.2s;
            width: 100%;
          }
          .oli-mobile-sublink:hover { color: #CFA047 !important; }
        }
      `}</style>

      <nav className="oli-navbar">
        <div className="container d-flex align-items-center" style={{ position: 'relative' }}>
          {/* Brand */}
          <Link className="oli-brand" to="/">
            <img src="/images/logo.png" alt="Logo" style={{ height: '36px', width: 'auto', objectFit: 'contain' }} />
          </Link>

          {/* Animated links area */}
          <div className="oli-links-wrapper" style={{ justifyContent: 'flex-end' }}>
            <div className="oli-links-track">
              {secondaryLinks.map((item, i) => {
                const isServices = item.label === 'Services';
                return (
                  <React.Fragment key={item.label}>
                    {i > 0 && <span className="oli-sep">|</span>}
                    <div className="oli-nav-item" style={{ animationDelay: `${i * 0.06}s` }}>
                      {item.href.startsWith('/') ? (
                        <Link
                          className="oli-nav-link"
                          to={item.href}
                        >
                          {item.label}
                          {isServices && (
                            <i className="fa-solid fa-caret-down caret"></i>
                          )}
                        </Link>
                      ) : (
                        <a
                          className="oli-nav-link"
                          href={item.href}
                        >
                          {item.label}
                          {isServices && (
                            <i className="fa-solid fa-caret-down caret"></i>
                          )}
                        </a>
                      )}
                      {isServices && (
                        <div 
                          className="oli-mega-menu"
                          style={{
                            width: `${primaryLinks.length * 150}px`,
                            gridTemplateColumns: `repeat(${primaryLinks.length}, 1fr)`
                          }}
                        >
                          {primaryLinks.map((subItem) => {
                            const linkPages = dynamicPages.filter(p => p.menu_title === subItem.label);
                            return (
                              <div key={subItem.label} className="oli-mega-col">
                                <div className="oli-mega-col-title" style={{ cursor: 'default' }}>
                                  {subItem.label}
                                </div>
                                {isLoading ? (
                                  <div className="oli-mega-item" style={{ color: '#888', fontStyle: 'italic', paddingLeft: '5px' }}>
                                    <i className="fa-solid fa-circle-notch fa-spin"></i> Loading...
                                  </div>
                                ) : linkPages.length > 0 ? (
                                  linkPages.map(page => (
                                    <a key={page.id} href={`/pages/${page.slug}`} className="oli-mega-item">
                                      {page.title}
                                    </a>
                                  ))
                                ) : (
                                  <div className="oli-mega-item" style={{ color: '#aaa', fontStyle: 'italic', paddingLeft: '5px' }}>
                                    No services
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>

          {/* Mobile Toggle Button */}
          <button 
            className="oli-mobile-toggle" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`fa-solid ${mobileMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="oli-mobile-menu d-lg-none">
            {secondaryLinks.map((item) => {
              const isServices = item.label === 'Services';
              return (
                <React.Fragment key={item.label}>
                  <a 
                    className="oli-nav-link" 
                    href={item.href}
                    onClick={() => !isServices && setMobileMenuOpen(false)}
                  >
                    {item.label}
                    {isServices && <i className="fa-solid fa-caret-down text-muted" style={{ fontSize: '12px' }}></i>}
                  </a>
                  {isServices && (
                    <div style={{ padding: '12px 24px', display: 'flex', flexDirection: 'column', gap: '14px', background: 'rgba(0,0,0,0.2)', borderBottom: '1px solid #1a2a40' }}>
                      {primaryLinks.map(subItem => {
                        const linkPages = dynamicPages.filter(p => p.menu_title === subItem.label);
                        const hasSub = isLoading || linkPages.length > 0;
                        return (
                          <React.Fragment key={subItem.label}>
                            <div 
                              className="oli-mobile-sublink" 
                              style={{ fontWeight: 700, color: '#CFA047', cursor: 'default', pointerEvents: 'none' }}
                            >
                              <span>{subItem.label}</span>
                              {hasSub && <i className="fa-solid fa-caret-down text-muted" style={{ fontSize: '12px' }}></i>}
                            </div>
                            {hasSub && (
                              <div style={{ paddingLeft: '16px', display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '4px', borderLeft: '1px solid rgba(255,255,255,0.1)', marginLeft: '6px' }}>
                                {isLoading ? (
                                  <div className="oli-mobile-sublink" style={{ fontSize: '13px', color: '#64748b', fontStyle: 'italic' }}>
                                    <span><i className="fa-solid fa-circle-notch fa-spin"></i> Loading...</span>
                                  </div>
                                ) : linkPages.length > 0 ? (
                                  linkPages.map(page => (
                                    <a 
                                      key={page.id} 
                                      href={`/pages/${page.slug}`} 
                                      className="oli-mobile-sublink" 
                                      style={{ fontSize: '13px', color: '#94a3b8' }}
                                      onClick={() => setMobileMenuOpen(false)}
                                    >
                                      {page.title}
                                    </a>
                                  ))
                                ) : (
                                  <div className="oli-mobile-sublink" style={{ fontSize: '13px', color: '#64748b', fontStyle: 'italic' }}>
                                    No services
                                  </div>
                                )}
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
